<app-form   [items]="formItems"
            [options]="formOptions">  
</app-form>